import { render, staticRenderFns } from "./ReportLawyerDepartment.vue?vue&type=template&id=f5c5732e"
import script from "./ReportLawyerDepartment.vue?vue&type=script&lang=js"
export * from "./ReportLawyerDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports